/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CaseMatchClinic } from './CaseMatchClinic';

export type CaseMatchPatient = {
    readonly id?: number;
    first_name: string;
    last_name?: string | null;
    middle_initial?: string | null;
    date_of_birth?: string | null;
    /**
     * HL7 single character representation of sex: F, M, O, U, A
     */
    sex?: CaseMatchPatient.sex | null;
    readonly clinic?: CaseMatchClinic;
}

export namespace CaseMatchPatient {

    /**
     * HL7 single character representation of sex: F, M, O, U, A
     */
    export enum sex {
        M = 'M',
        F = 'F',
        O = 'O',
        U = 'U',
        A = 'A',
    }


}
